import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'antd';
import { RightOutlined, RobotFilled } from '@ant-design/icons';
import { getAssetia } from "../../../API/assetia";
import ia from './assets/ia.png';
import './Assetia.css';

const Assetia = ({ pageTitle, pageDescription, view }) => {
  const [tips, setTips] = useState([]);
  const [tipIndex, setTipIndex] = useState(-1);

  useEffect(() => {
    const fetchTips = async () => {
      try {
        const response = await getAssetia();
        if (response && response[view]) {
          const sortedTips = response[view].sort((a, b) => a.index - b.index);
          // podés usar solo description, o name + description
          setTips(sortedTips.map(t => ` ${t.description}`));
        } else {
          setTips([]);
        }
      } catch (error) {
        console.error("Error al obtener tips de Assetia:", error);
        setTips([]);
      }
    };

    fetchTips();
  }, [view]);

  const handleNextTip = () => {
    if (tipIndex === tips.length - 1) {
      setTipIndex(-1);
    } else {
      setTipIndex(prevIndex => prevIndex + 1);
    }
  };

  return (
    <div id="assetia-section" className="assistant-container">
      <Row align="middle" gutter={[16, 16]}>
        <Col span={7} className="assistant-icon">
          <RobotFilled className="robot-icon" />
        </Col>

        <Col span={17} className="assistant-content">
          <h2>
            <span className="assetia">Hola soy ASSET</span>
            <span className="ia">IA</span>
          </h2>
          <p className="assistant-description">Tu asistente personal</p>

          {tipIndex === -1 ? (
            <p className="assistant-text">
              Bienvenido a la página de <strong>{pageTitle}</strong>, aquí puedes {pageDescription}.
            </p>
          ) : (
            <div className="assistant-tip">
              <p>{tips[tipIndex]}</p>
            </div>
          )}

          <Row gutter={8} className="assistant-buttons">
            <Col>
              <Button
                className="next-advice-button"
                onClick={handleNextTip}
                disabled={tips.length === 0}
              >
                {tipIndex === -1
                  ? 'Ver consejos'
                  : tipIndex === tips.length - 1
                    ? 'Volver al inicio'
                    : 'Siguiente consejo'} <RightOutlined />
              </Button>
            </Col>
            <Col className="reload-image-container">
              <img src={ia} alt="IA" className="reload-image" />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Assetia;